import "./ContactUs.css";
import { useState } from "react";
import {Link} from "react-router-dom";

export default function ContactUs() {

    const [mexData, setMexData] = useState({});
    const [number, setNumber] = useState("");

    function handleChange(e) {
        setMexData({...mexData, [e.target.id]: e.target.value});
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('name', mexData.name);
        formData.append('surname', mexData.surname);
        formData.append('email', mexData.email);
        formData.append('number', number);
        formData.append('message', mexData.message);

        try {
            const response = await fetch('/backend/send_helpemail.php', {
                method: 'POST',
                body: formData,
            });

            const data = await response.text();
            alert(JSON.parse(data).message);
        } catch (error) {
            console.error('Errore durante l\'invio dell\'email:', error);
            alert('Errore durante l\'invio dell\'email.');
        }
    };

    return (
        <div>
            <div id="formTitle">
                Compila il Form per Contattarci
            </div>
            <div id="formCaption">
                Per contatti e per informazioni sui prodotti, sul sito web o sulle condizioni di vendita non esitare a
                contattarci.
            </div>
            <form onSubmit={handleSubmit}>
                <div id="userData">
                    <div id="formComponent">
                        <input id="name" placeholder="Nome*" type="text" required onChange={(e) => handleChange(e)}/>
                    </div>
                    <div id="formComponent">
                        <input id="surname" placeholder="Cognome*" type="text" required
                               onChange={(e) => handleChange(e)}/>
                    </div>
                    <div id="formComponent">
                        <input id="email" placeholder="Email*" type="email" required onChange={(e) => handleChange(e)}/>
                    </div>
                    <div id="formComponent">
                        <input
                            id="number"
                            placeholder="Cellulare"
                            type="tel"
                            value={number}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) { // Accetta solo numeri
                                    setNumber(value);
                                }
                            }}
                        />
                    </div>
                </div>

                <div id="formComponent" className="message">
                    <textarea id="message" placeholder="Messaggio*" required onChange={(e) => handleChange(e)}/>
                </div>

                <div id="privacyDisclamer">
                    *Cliccando sul tasto "Contattaci" dichiari di aver letto e accettato <Link
                    to="/privacypage"> le nostre condizioni riguardanti la privacy</Link> ai sensi del Dlgs 196 del 30
                    giugno 2003 e dell'art. 13 GDPR.
                </div>

                <button id="submitButton">CONTATTACI</button>
            </form>
        </div>
    )
}